var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('dead.header', { framaservice: _vm.$t('color.story')}))}}),_vm._v(" "),_c('h3',{domProps:{"innerHTML":_vm._s(_vm.$t('dead.more'))}}),_vm._v(" "),_c('ul',[_c('li',{domProps:{"innerHTML":_vm._s(_vm.$t('dead.cloud', {
        link: 'https://framagit.org/framasoft/pickweaver/-/wikis/home',
      }))}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.$t('dead.contact'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }